import { AgeRestrictionDto } from '@/features/dashboard/tourOptions/types/TourOptionDto.ts';
import { PublicTourPriceWebDto } from '@/features/public/booking/types/BookingTourBasicDataDto.ts';
import { formatPrice } from '@/utils/formatters.ts';

export const formatAgeRestrictionLabel = (
  restriction: AgeRestrictionDto | null,
): string => {
  if (!restriction) return '';
  if (restriction.minAge && restriction.maxAge) {
    return `${restriction.minAge}-${restriction.maxAge} lat`;
  }
  if (restriction.minAge) {
    return `${restriction.minAge}+ lat`;
  }
  if (restriction.maxAge) {
    return `do ${restriction.maxAge} lat`;
  }
  return '';
};

/**
 * Etykieta chipa przy pozycji cennika albo `null`, gdy pozycji nie ma czym
 * opisać. Jedna cena bez progu wiekowego zostaje bez chipa — „Pozostali” przy
 * jedynej cenie sugerowałoby, że gdzieś jest jeszcze druga.
 */
export const formatPriceRowLabel = (
  entry: PublicTourPriceWebDto,
  priceCount: number,
): string | null => {
  if (entry.name) return entry.name;

  const ageLabel = formatAgeRestrictionLabel(entry.ageRestriction);
  if (ageLabel) return ageLabel;

  return priceCount >= 2 ? 'Pozostali' : null;
};

/**
 * Najtańszy wariant jako zapowiedź kosztu w zwiniętym pudełku o wyjeździe.
 * Przy jednej pozycji „od” byłoby kłamstwem, więc znika.
 */
export const formatLowestPriceHint = (
  prices: PublicTourPriceWebDto[] | null,
): string | null => {
  if (!prices || prices.length === 0) return null;

  const lowest = prices.reduce((cheapest, entry) =>
    entry.price.amount < cheapest.price.amount ? entry : cheapest,
  );
  const formatted = formatPrice(lowest.price.amount, lowest.price.currency);

  return prices.length === 1 ? formatted : `od ${formatted}`;
};
